import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PackageX } from "lucide-react";
import { api } from "@/lib/api";
import { fmtQty } from "@/lib/format";

export function StockAlert() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/magazzino/alert").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data?.count) return null;
  const names = data.items.slice(0, 3).map((p) => `${p.nome} (${fmtQty(p.giacenza)} pz)`).join(", ");
  return (
    <Link to="/magazzino?stato=sotto" data-testid="stock-alert" className="flex items-center gap-3 rounded-2xl border border-[#E07A5F]/30 bg-[#E07A5F]/10 px-4 py-3 text-sm text-[#7A3B2B] hover:bg-[#E07A5F]/15 transition-colors">
      <PackageX className="h-4 w-4 shrink-0" />
      <span><b data-testid="stock-alert-count">{data.count} {data.count === 1 ? "prodotto" : "prodotti"} sotto scorta</b> · {names}{data.count > 3 ? "…" : ""}</span>
      <span className="ml-auto text-xs font-semibold whitespace-nowrap">Vai al magazzino →</span>
    </Link>
  );
}
